import { isString } from 'lodash';

export function convertDate(date: string | Date) {
  return isString(date) ? new Date(date) : date;
}
